var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GmapMap',{staticStyle:{"width":"700px","height":"500px"},attrs:{"center":{ lat: _vm.lat, lng: _vm.lon },"zoom":15,"map-type-id":"terrain"}},[_c('GmapMarker',{ref:"myMarker",attrs:{"position":_vm.google && new _vm.google.maps.LatLng(_vm.lat, _vm.lon)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }